import { Loader2 } from "lucide-react";
import { cn } from "@/utils";

/**
 * Spinner
 *
 * Minimal loading indicator. Use `label` to describe what is loading for
 * assistive tech; the visible spinner is marked `aria-hidden`.
 */
export interface SpinnerProps {
  size?: number;
  label?: string;
  className?: string;
}

export function Spinner({ size = 16, label = "Loading", className }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className={cn("inline-flex", className)}>
      <Loader2
        size={size}
        className="animate-spin text-text-secondary"
        aria-hidden
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
